import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config, ApiVisa } from "../../shared";
import { BranchDefaultPrintableFormatHdrContainerModel } from "../../../../../../models/aggregates/branch/branch-default-printable-format-container.model";

@Injectable({
  providedIn: "root",
})
export class BranchDefaultPrintableFormatHdrService extends BaseApiTemplateService<BranchDefaultPrintableFormatHdrContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "branch-default-printable-hdrs/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "branch-default-printable-hdrs/backoffice-ep";
    this.httpClient = http;
  }
}
